import React from 'react';
import axios from "axios";
import { BUBBLE_LOADING, META_FACEBOOK, BREADCRUMB_SCHEMA } from '../../constants/FrontEndConstant';
import { LANGUAGE_CODE, API_URL, META_TITLE_APPEND } from '../../constants/DotEnv';
import AgbHeader from '../subPageHeader/SubPageHeader';
class Agb extends React.Component {
    constructor() {
        super();
        this.state = {
            agbdata: {},
            loading: 'false',
            dataLength: '',
            title: ''
        }
    }
    componentWillUnmount() {
        setTimeout(() => {
            window.setOgTag(META_FACEBOOK['og_title'], META_FACEBOOK['og_description'], META_FACEBOOK['og_image'], META_FACEBOOK['og_url'])
            window.removeSchema();
        }, 100)
    }
    componentDidMount() {
        this.scrollUpFunction();
        this.agbContent();
        setTimeout(() => {
            var schema2 = window.positionCreate(BREADCRUMB_SCHEMA['agb']['schema2']['position'], BREADCRUMB_SCHEMA['agb']['schema2']['url'], BREADCRUMB_SCHEMA['agb']['schema2']['name']);
            var schemaObject = window.schemaObj(BREADCRUMB_SCHEMA['schema1'], schema2, BREADCRUMB_SCHEMA['agb']['schema3']);
            window.setSchema(schemaObject);
        }, 100)
    }
    scrollUpFunction = () => {
        /**for scrolling up page */
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        let count = document.querySelector('.navbar-toggler').className.indexOf("collapsed");
        if (count === -1) {
            document.querySelector('.navbar-collapse').classList.remove('show');
            document.querySelector('header').classList.remove("header_collapse");
            document.querySelector('.navbar-toggler').setAttribute("aria-expanded", false);
        }
    }
    agbContent = () => {
        this.setState({ loading: 'true' })
        let self = this;
        let agbdata = '';
        let dataLength = '';
        let title = '';
        let meta_title = '';
        let meta_description = '';
        let meta_keywords = '';
        let og_title = '';
        let og_description = '';
        let og_image = '';
        axios.get(API_URL + '/cms/getCmsByID/88/' + LANGUAGE_CODE)
            .then((response) => {
                agbdata = response.data.success.cms;
                dataLength = Object.keys(agbdata).length;
                title = agbdata['title'];
                meta_title = agbdata['title'] + META_TITLE_APPEND;
                meta_description = agbdata['metadescription'];
                meta_keywords = agbdata['metakeyword'];
                og_title = agbdata['title'] + META_TITLE_APPEND;
                og_description = agbdata['metadescription'];
                og_image = META_FACEBOOK['og_image'];
                window.setMeta({ "description": meta_description, "keywords": meta_keywords });
                window.setOgTag(og_title, og_description, og_image, window.location.href)
                window.setDocumentTitle(meta_title)
                self.setState({ loading: 'false', agbdata, dataLength, title })
            })
            .catch((error) => {
                self.setState({ loading: 'false' })
            })
    }
    render() {
        let length = Object.keys(this.state.agbdata).length
        let agbdata = this.state.agbdata;
        return (
            <main>
                {(this.state.loading === 'true') ?
                    BUBBLE_LOADING
                    : null
                }
                <AgbHeader data={agbdata} title={this.state.title} dataLength={this.state.dataLength} />
                {(length > 0 && this.state.loading === 'false') ?
                    <section className="section-blog">
                        <div className="container">
                            <div className="row">
                                <div className="col-12 col-md-12">
                                    <div className="blog-lising">
                                        <div dangerouslySetInnerHTML={{ __html: agbdata['content'] }}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    : null
                }
            </main>
        );
    }
}
export default Agb;